import { NdmsRouteResolverGuard } from './../../../../projects/shared/core/services/ndms-route-resolver.guard';
import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NdmsAuthService } from "../../shared/core-ndms/services/ndms-auth.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AppSelectComponent } from "../app-select/app-select.component";
import { NdmsSafeSubscriber } from '../../../../projects/shared/core/interfaces/ndms-safe-subscriber';
import { BehaviorSubject } from 'rxjs';
import { ApplicationItemViewModel } from './application-item.view-model';
import { NdmsHomeService } from './home.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends NdmsSafeSubscriber implements OnInit {
  iconBase: string = "";
  approvedApps: any = {};
  bsModalRef: BsModalRef = null;
  modalCancelClicked: boolean = false;
  applicationItem: ApplicationItemViewModel
  appGroups?: string[];
  applicationsLoading = false;

  _applications$ = new BehaviorSubject(new Array<ApplicationItemViewModel>());
  get applications$() {
    return this._applications$.asObservable();
  };

  get applications() {
    return this._applications$.value;
  }

  get isLoggedIn() {
    return this.ndmsAuthService.isAuthorized;
  }

  constructor(@Inject('BASE_URL') baseUrl: string,
    private ndmsAuthService: NdmsAuthService,
    private _modalService: BsModalService,
    private _title: Title,
    private homeService: NdmsHomeService,
    @Inject('WELCOME') public welcome: string,
    @Inject('LOGIN_WELCOME') public loginWelcome: string
  ) {
    super();

    this._title.setTitle("Home - NDMS Suite");
    this.iconBase = baseUrl;
    this.safeSubscribe(this.homeService.applications$, (applications) => this._applications$.next(applications));
  }

  ngOnInit() {
    if (!this.homeService.initialApplicationsLoaded) {
      this.applicationsLoading = true;
      this.homeService.getAllApplications()
        .then(() => {
          NdmsRouteResolverGuard.PreloadIndicator = false;
          this.homeService.setUserApplications().finally(() => this.applicationsLoading = false);
        })
        .finally(() => {
          this.homeService.initialApplicationsLoaded = true;
        });
    }

    let bpb = document.querySelector('[bypass-block]');
    if (bpb instanceof HTMLElement) {
      bpb.focus();
      bpb.blur();
    }
  }

  onLoginButtonClick() {
    this.ndmsAuthService.login();
  }

  showAddApplicationsModal(event?) {
    if (this.bsModalRef !== null) return;

    let activeElement = document.activeElement;
    let pointerType = event ? event.pointerType : '';

    this.bsModalRef = this._modalService.show(AppSelectComponent, { class: 'modal-lg', ignoreBackdropClick: true });
    this.bsModalRef.content.model = this.applications.filter(k => k.isActive === true).filter(i => !i.visible || i.isDisabled);
    this._modalService.onHide.pipe(first()).subscribe(() => {
      if (this.bsModalRef !== null) this.bsModalRef = null; //uncaught close state via esc key
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        if (pointerType == "mouse") activeElement.blur();
      }
    });
    this.bsModalRef.content.complete.subscribe(() => {
      this.homeService.setUserApplications().then((userApps) => {
        console.log('user applications', userApps);

        if (userApps.length == 0 && !this.modalCancelClicked) {
          this.showAddApplicationsModal();
        } else {
          this.refreshApplicationsView().then(() => {
            this.bsModalRef.hide();
            this.bsModalRef = null;
          });
        }
      });
    });
    this.bsModalRef.content.cancel.subscribe(() => {
      this.modalCancelClicked = true;
      this.homeService.setUserApplications().then((userApps) => {
        console.log('user applications', userApps);

        if (userApps.length == 0 && !this.modalCancelClicked) {
          this.showAddApplicationsModal();
        } else {
          this.bsModalRef.hide();
          this.bsModalRef = null;
        }
      });
    });
  }

  private refreshApplicationsView(): Promise<void> {
    return new Promise((resolve) => {
      let applications = this.applications;
      this._applications$.next([]);
      setTimeout(() => {
        this._applications$.next(applications);
        return resolve();
      }, 0);
    })
  }

  onMainContentClick() {
    let mc = document.querySelector('[main-content]');
    if (mc instanceof HTMLElement) {
      mc.focus();
      mc.blur();
    }
  }
}

@Pipe({
  name: 'groupApplicationsBy'
})
export class GroupApplicationsByPipe implements PipeTransform {

  transform(applications: any, group?: any): any {
    if (!applications) {
      return [];
    }
    if (!group) {
      return [];
    }
    return applications.filter(ap => ap.appGroup === group) || [];
  }
}
